import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import { IAlarmNotificationCountModel } from "../../services/alarm-data-service/Models";
import AlarmDataService from "../../services/alarm-data-service/AlarmDataService";

export type UseAlarmNotificationCountsParams = {
    organizationID: number,
    contextGroupID: number,
    //queryParams: IQueryAlarmNotificationParams
    startDate: Date,
    endDate: Date
} & BaseUseQueryParameters<IAlarmNotificationCountModel[] | undefined>;

export function useAlarmNotificationCounts({
    
    organizationID,    
    contextGroupID,
    //queryParams,
    startDate,
    endDate,
    enabled,    
    refreshSeconds,
    onSuccess,
    onError
}: UseAlarmNotificationCountsParams) {
    return useQuery<IAlarmNotificationCountModel[], RestError>(
        keys.alarmNotificationCounts(organizationID, contextGroupID, startDate, endDate),
        ({ signal }) => {
            return AlarmDataService.queryAlarmNotificationCounts(
                organizationID,
                contextGroupID,
                startDate,
                endDate,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds  * 1000 : false,

        }
    );
}